// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__sendMsg__T1xRG {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.styles_action__sendMsg__Upezf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}


@media (max-width: 768px) {
  .styles_action__sendMsg__Upezf {
    flex-direction: column-reverse;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/components/ChatAssincrono/SendMsg/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE;IACE,8BAA8B;EAChC;;AAEF","sourcesContent":[".container__sendMsg {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.action__sendMsg {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n\n@media (max-width: 768px) {\n  .action__sendMsg {\n    flex-direction: column-reverse;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container__sendMsg": `styles_container__sendMsg__T1xRG`,
	"action__sendMsg": `styles_action__sendMsg__Upezf`
};
export default ___CSS_LOADER_EXPORT___;
